import React from "react";
import { SocketContext } from "./SocketProvider.context";

export function useSocketContext() {
  const context = React.useContext(SocketContext);

  if (!context) {
    throw new Error("SocketContext: Context must be used inside AuthProvider");
  }

  return context;
}

export const useWhatsappMessageReceivedSocket = () => {
	const { socket } = useSocketContext();
	console.log("socket", socket);

	const [whatsappMessageReceived, setWhatsappMessageReceived] = React.useState<{
        conversation: any;
		status: "RECEIVED" | "NEW_MESSAGE" | "MESSAGE_RECEIVED" | "MESSAGE_SENT" | "MESSAGE_STATUS_RECEIVED" |null;
		uuid: string | null;
	}>
	({
		conversation: null,
		status: null,
		uuid: null,
	});

	React.useEffect(() => {
		if (!socket) return;

		socket.on("RECEIVED", (data: any) => {
			if (data.status === "RECEIVED") {
				setWhatsappMessageReceived((prev) => ({
					...prev,
					status: "RECEIVED",
				}));
			}
		});

		socket.on("NEW_MESSAGE", (data) => {
			if (data.status === "NEW_MESSAGE") {
				setWhatsappMessageReceived((prev) => ({
					...prev,
					status: "NEW_MESSAGE",
				}));
			}
		});

		socket.on("KUCH_BHI", (data) => {
			console.log("KUCH_BHI Event:", socket.id, data);
		});
	}, [socket]);

	return whatsappMessageReceived;
};

export interface LeadSocketPayload {
	message: string;
	status: string;
	contact_number: string;
	user_name?:string
}

export type LeadEventName = "GOOGLE_LEAD" | "EXOTEL_LEAD" | "CAMPAIGNLEAD" | "upcomingFollowupLead";

export const useLeadSocket = () => {
	const { socket } = useSocketContext();
	const [leadAlert, setLeadAlert] = React.useState<{
		eventName: LeadEventName | null;
		message: string;
		status: string;
		contact_number: string;
		user_name?:string
	} | null>(null);

	React.useEffect(() => {
		if (!socket) return;

		const onGoogleLead = (data: LeadSocketPayload) => {
			setLeadAlert({
				eventName: "GOOGLE_LEAD",
				message: data?.message ?? "",
				status: data?.status ?? "ONGOING",
				contact_number: data?.contact_number ?? "",
				// user_name: data?.user_name ?? "",
			});
		};
		const onExotelLead = (data: LeadSocketPayload) => {
			setLeadAlert({
				eventName: "EXOTEL_LEAD",
				message: data?.message ?? "",
				status: data?.status ?? "ONGOING",
				contact_number: data?.contact_number ?? "",
			});
		};
		const onCampaignLead = (data: LeadSocketPayload) => {
			setLeadAlert({
				eventName: "CAMPAIGNLEAD",
				message: data?.message ?? "",
				status: data?.status ?? "ONGOING",
				contact_number: data?.contact_number ?? "",
			});
		};
		const onUpcomingFollowupLead = (data: LeadSocketPayload) => {
			console.log("🔔 Upcoming Followup Lead Received:", data);
			setLeadAlert({
				eventName: "upcomingFollowupLead",
				message: data?.message ?? "",
				status: data?.status ?? "ONGOING",
				contact_number: data?.contact_number ?? "",
				user_name: data?.user_name ?? "",
			});
		};

		const onAnyLead = (eventName: string, data: LeadSocketPayload) => {
			console.log(`🔔 Global Lead Alert [${eventName}]:`, data);
		};

		socket.on("GOOGLE_LEAD", onGoogleLead);
		socket.on("EXOTEL_LEAD", onExotelLead);
		socket.on("CAMPAIGNLEAD", onCampaignLead);
		socket.on("upcomingFollowupLead", onUpcomingFollowupLead);
		
		// For debugging global receipt
		socket.onAny && socket.onAny(onAnyLead);

		return () => {
			socket.off("GOOGLE_LEAD", onGoogleLead);
			socket.off("EXOTEL_LEAD", onExotelLead);
			socket.off("CAMPAIGNLEAD", onCampaignLead);
			socket.off("upcomingFollowupLead", onUpcomingFollowupLead);
			socket.offAny && socket.offAny(onAnyLead);
		};
	}, [socket]);

	return leadAlert;
};
